import script from "./newhome.vue?vue&type=script&setup=true&lang=js"
export * from "./newhome.vue?vue&type=script&setup=true&lang=js"

import "./newhome.vue?vue&type=style&index=0&id=11e74780&lang=less&scoped=true"
script.__scopeId = "data-v-11e74780"

export default script